import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Stack } from '@mui/material';

import { userInfoAtom } from '@/interfaces/member';
import { stockLoginAtom } from '@/interfaces/auth';
import TopBar from '@/components/common/TopBar';

export default function InventoryContainer() {
  const { data: userInfo, isLoading } = useAtomValue(userInfoAtom);
  const { data: token, isPending } = useAtomValue(stockLoginAtom);
  const navigate = useNavigate();

  const [src, setSrc] = useState('');

  useEffect(() => {
    if (userInfo) return;
    navigate('/login');
  }, [navigate, userInfo]);
  useEffect(() => {
    if (isPending) return;
    const url = new URL(process.env.REACT_APP_INVENTORY_URL + '/inventory/home');
    url.searchParams.set('accessToken', token.accessToken);
    url.searchParams.set('refreshToken', token.refreshToken);
    setSrc(url.toString());
  }, [isPending, token]);

  if (isLoading || !userInfo) return <></>;
  return (
    <>
      <TopBar containerMode />
      <Box component="main" sx={{ flexGrow: 1, display: 'flex' }}>
        {isPending || src === '' ? (
          <Stack alignItems="center" justifyContent="center" sx={{ flexGrow: 1 }}>
            <CircularProgress size={64} />
          </Stack>
        ) : (
          <iframe title="Inventory Management" src={src} width="100%" height="100%" style={{ border: 0 }} />
        )}
      </Box>
    </>
  );
}
